module.exports = __webpack_public_path__ + "prod/20251205101532/img/download-icon.96836c70.png";